export enum PassengerType {
  Adult = 'ADT',
  Child = 'CHD',
  Infant = 'INF',
}
